"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const clsx_1 = __importDefault(require("clsx"));
const useStyles = (0, core_1.makeStyles)((theme) => ({
    container: { display: 'flex', flexDirection: 'column' },
    headerContainer: {
        fontSize: '1.5rem',
        fontWeight: 600,
    },
    requiredBox: {
        // Adding alpha to background color
        backgroundColor: theme.palette.primary.main + '16',
        padding: '0.25rem 0.75rem',
        borderRadius: '0.25rem',
        marginLeft: '0.25rem',
        fontSize: '0.75rem',
        fontWeight: 600,
        color: theme.palette.primary.main,
    },
    optionalBox: {
        // Adding alpha to background color
        backgroundColor: theme.palette.text.primary + '16',
        padding: '0.25rem 0.75rem',
        borderRadius: '0.25rem',
        marginLeft: '0.25rem',
        fontSize: '0.75rem',
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    description: {
        fontSize: '1rem',
        fontWeight: 400,
    },
    diver: { backgroundColor: theme.palette.primary.main, height: '0.14rem', marginTop: '0.30rem' },
}));
const StyledHeader = (props) => {
    const { title, required, optional, description, classes } = props;
    const myClasses = useStyles();
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(myClasses.container, classes === null || classes === void 0 ? void 0 : classes.root) },
        react_1.default.createElement("div", { style: { display: 'flex' } },
            react_1.default.createElement("div", { className: myClasses.headerContainer },
                title,
                description && react_1.default.createElement("span", { className: myClasses.description }, description),
                required && react_1.default.createElement("span", { className: myClasses.requiredBox }, "Required"),
                optional && react_1.default.createElement("span", { className: myClasses.optionalBox }, "Optional"))),
        react_1.default.createElement("div", { className: myClasses.diver })));
};
exports.default = StyledHeader;
